'use client';

import { createContext } from 'react';

import type { MenuRootContextInterface } from '../types/menu-root.types';

export const MenuRootContext = createContext({} as MenuRootContextInterface);

MenuRootContext.displayName = 'Menu.Root.Context';
